import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  Optional,
  Self,
} from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms'; // Import FormControl

@Directive({
  selector: '[mdgTextFilter]',
})
export class MdgTextFilterDirective implements OnInit {
  private filterChars = /[=!#$%^&*()@._+|}{":?><,/;'[\]~`]/g;
  private filterCharsEmails = /[=!#$%^&*()+|}{":?><,/;'[\]~`]/g;

  private element: HTMLInputElement;

  constructor(
    private inputElement: ElementRef<HTMLInputElement>,
    @Optional() private formGroupDirective: FormGroupDirective,
    @Optional() @Self() private formControl: FormControl
  ) {
    this.element = this.inputElement.nativeElement;

    const charsfilter = this.element.dataset.charsfilter;

    if (charsfilter) {
      if (charsfilter === 'email') {
        this.filterChars = this.filterCharsEmails;
      }
    }
  }
  ngOnInit(): void {
    this.processInput();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (this.filterChars.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  processInput(): void {
    var cursorPosition = this.element.selectionStart;

    var filteredValue = this.element.value
      .toUpperCase()
      .replace(this.filterChars, '');
    if (this.element.value !== filteredValue)
      this.element.value = filteredValue;

    if (this.formControl) {
      this.formControl.setValue(filteredValue, { emitEvent: false });
    }

    const controlName = this.inputElement.nativeElement.name;
    const controlPath = controlName.split('.'); //['billingAddressForm', 'email']

    var formGroup = this.formGroupDirective.form;

    if (controlName) {
      const control = this.findControl(formGroup, controlPath);
      if (control) {
        control.setValue(filteredValue, { emitEvent: false });
      }
    }

    var inputName = this.element.getAttribute('name') || '';
    if (inputName) {
      var formGroup = this.formGroupDirective.form;
      var control = formGroup.get(inputName);

      if (control) {
        control.setValue(filteredValue, { emitEvent: false });
      }
    }
    const docElement = document.getElementById(this.element.id);
    if (docElement && docElement instanceof HTMLInputElement) {
      docElement.value = filteredValue;
    }

    if (document.activeElement === this.element && cursorPosition !== null) {
      this.element.setSelectionRange(cursorPosition, cursorPosition);
    }

    if (!this.element['inputEventTriggered']) {
      this.element['inputEventTriggered'] = true;
      setTimeout(() => {
        this.element.dispatchEvent(new Event('input'));
        this.element['inputEventTriggered'] = false;
      }, 0);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    var clipboardData = event.clipboardData?.getData('text');
    if (clipboardData) {
      var filteredText = clipboardData
        .toUpperCase()
        .replace(this.filterChars, '');
      event.preventDefault();

      var start = this.element.selectionStart || 0;
      var end = this.element.selectionEnd || 0;
      var textBefore = this.element.value.substring(0, start);
      var textAfter = this.element.value.substring(end);

      this.element.value = textBefore + filteredText + textAfter;

      var newPosition = start + filteredText.length;
      this.element.setSelectionRange(newPosition, newPosition);

      this.element.dispatchEvent(new Event('input'));
    }
  }

  findControl(formGroup: any, controlPath: string[]) {
    if (controlPath.length === 0) {
      return null;
    }
    const currentControl = formGroup.controls[controlPath[0]];

    if (!currentControl) {
      return null;
    }
    if (controlPath.length === 1) {
      return currentControl;
    }

    if (currentControl instanceof FormGroup) {
      return this.findControl(currentControl, controlPath.slice(1));
    }

    return null;
  }
}
